const SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT: string = 'System Reports Emailed to Customers'

class Benefits {
  static readonly SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT = SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT

  static readonly PREMIUM = [
    'Unlimited Access to Tech Assistant AI Chatbot in Technician App',
    'Extended Runtime History',
    'Maintenance Trends',
    'Your Logo in Customer’s Home App',
    SYSTEM_REPORTS_EMAIL_PREMIUM_BENEFIT
  ]

  static readonly BASIC = [
    'Limited Access to Tech Assistant AI Chatbot in Technician App',
    '30 Days Runtime History',
    'Equipment Alerts and Smart Diagnostic Alerts',
    'Dealer Remote Configuration',
    'Warranty Information',
    'Service Contract Tracking',
    'Link Verification Reports'
  ]

  static values () {
    return [
      Benefits.PREMIUM,
      Benefits.BASIC
    ]
  }
}

export default Benefits
